import { useApp } from '../app-context';
import { useCountdown } from '../lib/useCountdown';

// Streak + next-puzzle countdown + share entry (best-practice §11.4 / §7.1).
export default function FootChips({ streak, done, onShare }: { streak: number; done: boolean; onShare: () => void }) {
  const { t } = useApp();
  const countdown = useCountdown();
  return (
    <div className="footchips">
      <div className="fc"><span className="n">{streak}</span> {t('streak')}</div>
      <div className="fc">{t('next')} <span className="n">{countdown}</span></div>
      {done && <button className="fc share" onClick={onShare}>⤴ {t('share')}</button>}
    </div>
  );
}
